// extracted by mini-css-extract-plugin
module.exports = {"c-prose":"Prose_c-prose__kdupx","legal-page-text":"Prose_legal-page-text__2Qw_k"};